/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { SmsProviderEnum } from './SmsProviderEnum';
import {
    SmsProviderEnumFromJSON,
    SmsProviderEnumFromJSONTyped,
    SmsProviderEnumToJSON,
} from './SmsProviderEnum';

/**
 * 
 * @export
 * @interface SmsProviderDto
 */
export interface SmsProviderDto {
    /**
     * 
     * @type {number}
     * @memberof SmsProviderDto
     */
    tenantId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SmsProviderDto
     */
    userCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmsProviderDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmsProviderDto
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmsProviderDto
     */
    origin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SmsProviderDto
     */
    customerCode?: string | null;
    /**
     * 
     * @type {SmsProviderEnum}
     * @memberof SmsProviderDto
     */
    provider?: SmsProviderEnum;
}

/**
 * Check if a given object implements the SmsProviderDto interface.
 */
export function instanceOfSmsProviderDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SmsProviderDtoFromJSON(json: any): SmsProviderDto {
    return SmsProviderDtoFromJSONTyped(json, false);
}

export function SmsProviderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsProviderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'userCode': !exists(json, 'userCode') ? undefined : json['userCode'],
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
        'customerCode': !exists(json, 'customerCode') ? undefined : json['customerCode'],
        'provider': !exists(json, 'provider') ? undefined : SmsProviderEnumFromJSON(json['provider']),
    };
}

export function SmsProviderDtoToJSON(value?: SmsProviderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'userCode': value.userCode,
        'userName': value.userName,
        'password': value.password,
        'origin': value.origin,
        'customerCode': value.customerCode,
        'provider': SmsProviderEnumToJSON(value.provider),
    };
}

